import { DI, resolve } from 'aurelia';
import { IFirebase } from './firebase';

/**
 * Server-synchronised clock so every client reveals the same ball at the same
 * moment, no matter how wrong the local system time is.
 */
export interface IClock {
  now(): number;
  offsetMs: number;
  sync(): Promise<void>;
}

export const IClock = DI.createInterface<IClock>('IClock', (x) => x.singleton(ClockService));

export class ClockService implements IClock {
  offsetMs = 0;
  private fb = resolve(IFirebase);
  private synced = false;

  now(): number {
    return Date.now() + this.offsetMs;
  }

  async sync(): Promise<void> {
    try {
      const t0 = Date.now();
      const { now } = await this.fb.call<void, { now: number }>('serverTime');
      const t1 = Date.now();
      const rtt = t1 - t0;
      this.offsetMs = now + rtt / 2 - t1;
      this.synced = true;
    } catch (e) {
      if (!this.synced) console.warn('Clock sync failed, using local time', e);
    }
  }
}
